var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-alert",class:'auth-alert--' + _vm.variant},[_c(_vm.icon,{tag:"component",staticClass:"auth-alert__icon",attrs:{"size":16}}),_vm._v(" "),_c('p',{staticClass:"auth-alert__text"},[_vm._v(_vm._s(_vm.message))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d23e71d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/auth/AuthAlert.vue
// module id = null
// module chunks = 